import React from "react";

import "../styles/Loader.css";

function Loader() {
  return <div className="Loader"></div>;
}

export default Loader;
